export const visit = (vm, at) => {
at({ "fi": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Ik\xE4v\xE4 kyll\xE4 emme voineet vahvistaa s\xE4hk\xF6postiosoitettasi." } } } });
};